// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"672":"d84ed775","702":"ca79fdb4"}[chunkId] + ".chunk.js";
};